export default __webpack_public_path__ + "images/price-icon_1.svg?72fe80cf18cc3b5afa3fbb47c1fef9e3";